declare global {
  interface Window {
    clarity?: (command: string, ...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, metadata?: Record<string, any>) => {
  if (window.clarity) {
    window.clarity("event", eventName, metadata);
  }
};

// User Journey Events
export const ClarityEvents = {
  // Landing and Navigation
  WEBSITE_VISIT: "website_visit",
  
  // Brand Selection
  BRAND_VIEW: "brand_view",
  BRAND_SELECT: "brand_select",
  
  // Model Selection
  MODEL_VIEW: "model_view",
  MODEL_SELECT: "model_select",
  
  // Service Selection
  SERVICE_VIEW: "service_view",
  SERVICE_ADD_TO_CART: "service_add_to_cart",
  SERVICE_REMOVE_FROM_CART: "service_remove_from_cart",
  
  // Cart Actions
  CART_VIEW: "cart_view",
  CART_UPDATE: "cart_update",
  
  // Order Process
  ORDER_INITIATE: "order_initiate",
  ORDER_PLACE: "order_place",
  
  // Address Management
  ADDRESS_VIEW: "address_view",
  ADDRESS_ADD: "address_add",
  ADDRESS_UPDATE: "address_update",
  
  // Authentication
  LOGIN_ATTEMPT: "login_attempt",
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILURE: "login_failure",
  
  // Payment
  PAYMENT_INITIATE: "payment_initiate",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILURE: "payment_failure"
} as const;

export type ClarityEventType = typeof ClarityEvents[keyof typeof ClarityEvents]; 